import { fetchFactureByNumber } from '../API/fetchFactureByNumber';

export const checkFactureExisting = async (nbrFact, selectedHotel, identifiant) => {
    const currentYear = new Date().getFullYear();
    const formatedDate = (dateString) => {
        const date = new Date(dateString);
        return date.getFullYear(); 
    };
    try {
        const facture = await fetchFactureByNumber(nbrFact, selectedHotel, identifiant);
        if (!facture || !facture.id_facture) {
            return '';
        }
        const factYear = formatedDate(facture.currentDate);
        const id_facture = facture.id_facture;
        if (currentYear !== factYear) {
            return '';
        }
        return `La facture existe et correspond à l'année en cours : ID facture ${id_facture}`;

    } catch (error) {
        console.error("Error checking facture existence:", error);
        return "Error checking facture existence";
    }
};
